(function (Drupal, $, Cookies) {
  'use strict';

  Drupal.behaviors.alert = {
    attach: function (context, settings) {
      $('[data-alert]', context === document ? context : $(context).parent()).each(function () {
        const $self = $(this);
        const id = $self.attr('data-alert');
        const cookieName = 'alert-' + id;

        const expirationCookieFound = Cookies.get(cookieName);
        if (expirationCookieFound) {
          return;
        }

        $self.addClass('shown');

        $self.find('.alert-close').click(function () {
          $self.removeClass('shown');
          const expirationMap = {
            '7 days': 7,
            '14 days': 14,
            '30 days': 30,
            // https://developer.chrome.com/blog/cookie-max-age-expires/
            'never': 400,
          };
          const expiryKey = $self.attr('data-expiry');
          if (Object.hasOwn(expirationMap, expiryKey)) {
            Cookies.set(cookieName, 1, { expires: expirationMap[expiryKey] });
          }
        });
      });
    },
  };
}(Drupal, jQuery, Cookies));
